module.exports = __webpack_public_path__ + "static/img/zzz.2a39635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/zzz.png
// module id = ZivZ
// module chunks = 1